// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-producto-container[data-v-be1a2b66]{max-width:600px}.my_divider[data-v-be1a2b66]{border:3px solid;border-radius:2px;max-width:5rem}", ""]);
// Exports
module.exports = exports;
